import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import FormInput from '../../../inputs/FormInput';
import MultiImageUploader from '../../../inputs/MultiImageUploader';

const MediaTab = ({
    cover,
    setCover,
    gallery,
    setGallery,
    isArabic
}) => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                    {isArabic ? 'صورة الغلاف' : 'Cover Image'}
                </Typography>
                <Box sx={{ border: '1px dashed #ddd', borderRadius: 2, p: 2, textAlign: 'center' }}>
                    <FormInput
                        type="file"
                        value={cover}
                        borderRadius={2}
                        onChange={(e) => setCover(e.target.value)}
                        labelImage={isArabic ? 'صورة الغلاف للمنتج' : 'Product Cover Image'}
                        width="100%"
                        height={220}
                    />
                    <Typography variant="caption" sx={{ mt: 1, display: 'block', color: 'text.secondary' }}>
                        {isArabic ? 'يفضل مقاس مربّع (1000x1000)' : 'Square size preferred (1000x1000)'}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12} md={8}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                    {isArabic ? 'معرض الصور' : 'Gallery Images'}
                </Typography>
                <Box sx={{ border: '1px dashed #ddd', borderRadius: 2, p: 2 }}>
                    <MultiImageUploader
                        value={gallery}
                        onChange={setGallery}
                        maxImages={10}
                    />
                </Box>
            </Grid>
        </Grid>
    );
};

export default MediaTab;
